import React, { useEffect, useState } from "react";
import api from '../../api/axiosInstance';
import AdminLayout from "../../components/admin/AdminLayout";
import { Form, Button, Alert } from "react-bootstrap";

const AddDisease = () => {
  const [formulas, setFormulas] = useState([]);
  const [message, setMessage] = useState(null);

  const [form, setForm] = useState({
    name: "",
    description: "",
    imageUrls: [""],
    relatedFormulas: [],
  });

  const loadFormulas = async () => {
    const res = await api.get("/formulas");
    setFormulas(res.data);
  };

  useEffect(() => {
    loadFormulas();
  }, []);

  // Tek tek resim ekleme
  const handleImageChange = (index, value) => {
    const updated = [...form.imageUrls];
    updated[index] = value;
    setForm({ ...form, imageUrls: updated });
  };

  const addImageField = () => {
    setForm({ ...form, imageUrls: [...form.imageUrls, ""] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");

    try {
      await api.post("/diseases", form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setMessage({ type: "success", text: "Hastalık eklendi!" });

      setForm({
        name: "",
        description: "",
        imageUrls: [""],
        relatedFormulas: [],
      });
    } catch (err) {
      setMessage({ type: "danger", text: "Hata oluştu" });
    }
  };

  return (
    <AdminLayout>
      <h2>➕ Yeni Hastalık Ekle</h2>

      {message && <Alert variant={message.type}>{message.text}</Alert>}

      <Form onSubmit={handleSubmit} className="mt-3">

        <Form.Group className="mb-3">
          <Form.Label>Hastalık Adı</Form.Label>
          <Form.Control
            name="name"
            value={form.name}
            required
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Açıklama</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            name="description"
            value={form.description}
            required
            onChange={(e) => setForm({ ...form, description: e.target.value })}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>İlgili Formüller</Form.Label>
          <Form.Select
            multiple
            value={form.relatedFormulas}
            onChange={(e) =>
              setForm({
                ...form,
                relatedFormulas: [...e.target.selectedOptions].map((o) => o.value),
              })
            }
          >
            {formulas.map((f) => (
              <option key={f._id} value={f._id}>
                {f.formulationName}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Label>Resim URL'leri</Form.Label>
        {form.imageUrls.map((url, index) => (
          <Form.Group key={index} className="mb-2">
            <Form.Control
              placeholder="https://..."
              value={url}
              onChange={(e) => handleImageChange(index, e.target.value)}
            />
          </Form.Group>
        ))}

        <Button variant="secondary" size="sm" onClick={addImageField}>
          + Yeni Resim Alanı
        </Button>

        <Button type="submit" className="mt-3" variant="primary">
          Kaydet
        </Button>
      </Form>
    </AdminLayout>
  );
};

export default AddDisease;
